// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__16nRt","container":"styles_container__2dE6n","classFooter":"styles_classFooter__3BRjt"};